export const QueryKeys = {
  CONTACT: ['contact'],
  NEWSLETTER: ['newsletter'],
  CAREERS: ['careers'],
};
